import { render, staticRenderFns } from "./Report_blockchainDetail.vue?vue&type=template&id=289ba96c&"
import script from "./Report_blockchainDetail.vue?vue&type=script&lang=js&"
export * from "./Report_blockchainDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports